import type { ApiFetchGiratudoPrizesPort } from '~/handlers/ports/api-fetch-giratudo-prizes.port';
import { getApostatudoApiUrl } from '~/utils/apostatudo/get-apostatudo-api-url';
import { getApostatudoAuthHeaders } from '~/utils/apostatudo/get-apostatudo-auth-headers';

export class ApostatudoApiFetchGiratudoPrizesAdapter
  implements ApiFetchGiratudoPrizesPort
{
  async handle(userId: number, page = 1, perPage = 10) {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 10000);

    const params = new URLSearchParams();

    params.append('user_id', userId.toString());
    params.append('page', page.toString());
    params.append('per_page', perPage.toString());

    const response = await fetch(
      `${getApostatudoApiUrl()}/hourly-raffle/my-prizes?${params.toString()}`,
      {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          ...getApostatudoAuthHeaders(),
        },
        signal: controller.signal,
      },
    ).finally(() => clearTimeout(timeoutId));

    if (!response.ok) {
      throw new Error(`Failed to fetch prizes: ${response.status}`);
    }

    const data = await response.json();

    return {
      data: data.data.map((entry: any) => ({
        position: entry.position,
        date: entry.date,
        ticketNumber: entry.ticket_number ?? entry.ticketNumber,
        prize: entry.prize,
        createdAt: entry.created_at ?? entry.createdAt,
      })),
      currentPage: data.current_page ?? data.currentPage,
      totalPages: data.total_pages ?? data.totalPages,
    };
  }
}
